import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * PrototypeBannerComponent
 *
 * A persistent, non-dismissible banner that identifies the build as a vision prototype
 * with mocked data. Renders at the top of the viewport on all pages.
 *
 * - Selector: `app-prototype-banner`
 * - No inputs, no outputs
 * - Banner text is a hard-coded constant
 * - Accessibility: `role="status"` for screen reader announcement
 */
@Component({
  selector: 'app-prototype-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './prototype-banner.component.html',
  styleUrl: './prototype-banner.component.scss',
})
export class PrototypeBannerComponent {
  /**
   * Hard-coded banner text — matches spec §8.5 exactly.
   * No dismiss mechanism, no state, no conditional rendering.
   */
  readonly bannerText =
    'Vision prototype. Every screen, number, and agent here is mocked to show the target experience. Nothing is wired to a live system yet.';
}
